import { createFileRoute } from "@tanstack/react-router";
import { IssueTypeEditView } from "#app/components/settings/issue-type-edit-view";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withInternal } from "#app/components/permissions/require-permission";

function IssueTypeEditPage() {
  const { issueTypeId } = Route.useParams();
  const { replace } = useAppNavigate();

  return (
    <IssueTypeEditView
      issueTypeId={issueTypeId}
      onBack={() => replace("/settings/issue-types")}
    />
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/issue-types/$issueTypeId",
)({ component: withInternal(IssueTypeEditPage) });
